import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48126467"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48126467')) {
      api.createRecord('48126467', component.options)
    } else {
      api.reload('48126467', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=48126467", function () {
      api.rerender('48126467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/routes/index.vue"
export default component.exports